var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('iframe',{attrs:{"sandbox":"allow-scripts allow-popups","src":_vm.iframeSrc,"title":"Earth Blox | All the power of Earth Engine without the coding"}})])}
var staticRenderFns = []

export { render, staticRenderFns }